<template>
  <MetaData :route="route" />
  <div class="flex flex-col">
    <placeholder name="jss-header" :pageTitle="pageTitle" :rendering="route" :globalAlerts="globalAlerts" />
    <div
      class="min-h-[calc(100svh-56px-376px)] md:min-h-[calc(100svh-68px-376px)]"
      :class="contentEditing ? 'lg:min-h-[200px]' : 'lg:min-h-[calc(100svh-69px-199px)]'"
    >
      <Login v-if="performLogin" />

      <placeholder
        v-if="!accountStore.loginVisible"
        name="headless-main"
        :rendering="route"
        :errorComponent="NotFound"
      />
      <FullScreenSpinner v-else />
    </div>
    <PaymentSecurityFooter :paymentOptions="paymentOptions" />
    <placeholder name="jss-footer" :rendering="route" />
  </div>
</template>

<script lang="ts" setup>
import { computed, getCurrentInstance } from 'vue';
import { Placeholder, Field, ComponentRendering } from '@sitecore-jss/sitecore-jss-vue';
import Login from '@/components/Login/Login.vue';
import PaymentSecurityFooter from '@/components/PaymentSecurityFooter/PaymentSecurityFooter.vue';
import { useAccountStore } from '@/store';
import { IPaymentSecurityFooterData } from '@/interfaces/forms/payment-security-footer.interface';
import { normalisePaymentOptions } from '@/utils/payment-security-footer';
import NotFound from './NotFound.vue';
import MetaData from './components/MetaData/MetaData.vue';
import FullScreenSpinner from '@/components/FullScreenSpinner/FullScreenSpinner.vue';

const app = getCurrentInstance();
const contentEditing = app?.appContext?.config?.globalProperties?.$jss?.sitecoreContext()?.pageEditing === true;

const props = defineProps<{
  route: ComponentRendering;
}>();

const accountStore = contentEditing ? { loginVisible: false } : useAccountStore();
const performLogin = computed(() => !contentEditing && (props.route.fields?.AuthenticationRequired as Field)?.value);
const pageTitle = computed(
  () => (props.route.fields?.pageTitle as Field)?.value || (props.route.fields?.Title as Field)?.value || ''
);

const globalAlerts = computed(() => {
  const globalAlertsField = props.route.fields?.GlobalAlerts as any;
  return globalAlertsField?.fields?.globalAlerts;
});

const paymentOptions = computed(() => normalisePaymentOptions(props.route.fields as IPaymentSecurityFooterData));
</script>
